import { render, staticRenderFns } from "./locking.vue?vue&type=template&id=289dfc73&scoped=true&"
import script from "./locking.vue?vue&type=script&lang=js&"
export * from "./locking.vue?vue&type=script&lang=js&"
import style0 from "./locking.vue?vue&type=style&index=0&id=289dfc73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289dfc73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('289dfc73')) {
      api.createRecord('289dfc73', component.options)
    } else {
      api.reload('289dfc73', component.options)
    }
    module.hot.accept("./locking.vue?vue&type=template&id=289dfc73&scoped=true&", function () {
      api.rerender('289dfc73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/dividend/locking.vue"
export default component.exports